export default __webpack_public_path__ + "static/media/food-insecure-mig-prep.56ebcee1.csv";